import { BaseLoadingOverlay } from "@/components/atom/loadingOverlay/BaseLoadingOverlay";
import { LoadingOverlayProps } from "@mantine/core";

interface GlobalLoaderProps extends LoadingOverlayProps {}

export const GlobalLoaderOverlay = ({ ...etcProps }: GlobalLoaderProps) => {
  return <BaseLoadingOverlay overlayColor="none" {...etcProps} />;
};
